import * as model from './models';
import { services } from '../../utils/service';

import createAxios from '@framework/http';
import { Form } from '@ks/kwai-ui';
const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.VUE_APP_NODE_ENV !== 'production' });

/** User Role Manage Controller  新增子账号 */
export async function addChildrenUserUsingPOST(params: { param: model.IAddUpdateChildrenUserParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/merchant/account/staffUser/add`, {
        ...params.param,
    });
    return result;
}

/** User Role Manage Controller  修改子账号 */
export async function updateInfoChildrenUserUsingPOST(params: { param: model.IAddUpdateChildrenUserParam }) {
    const result = await axios.post<model.IMessageboolean>(
        `/rest/merchant/account/staffUser/update`,
        { ...params.param }
    );
    return result;
}

/** User Role Manage Controller  删除子账号 */
export async function deleteChildrenUserUsingPOST(params: { param: model.IEnOrDisableOrDeleteChildrenParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/merchant/account/staffUser/delete`, {
        ...params.param,
    });
    return result;
}

/** User Role Manage Controller  停用子账号 */
export async function disableChildrenUserUsingPOST(params: { param: model.IEnOrDisableOrDeleteChildrenParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/merchant/account/staffUser/disable`, {
        ...params.param,
    });
    return result;
}

/** User Role Manage Controller  启用子账号 */
export async function enableChildrenUserUsingPOST(params: { param: model.IEnOrDisableOrDeleteChildrenParam }) {
    const result = await axios.post<model.IMessageboolean>(`/rest/merchant/account/staffUser/enable`, {
        ...params.param,
    });
    return result;
}

/** User Role Manage Controller  查询当前子账号基本信息 */
export async function getBasicCurrentUsingPOST(params: { param: model.IQueryBasicChildrenUserParam }) {
    const result = await axios.post<model.IMessageQueryBasicChildrenUserResultVO>(
        `/rest/merchant/account/staffUser/info`,
        { ...params.param }
    );
    return result;
}

/** User Role Manage Controller  查询可见的角色集合 */
export async function getCurrentAllRolesUsingPOST() {
    const result = await axios.post<model.IMessageListRoleVO>(`/rest/op/vc/merchant/userRoleManage/getCurrentAllRoles`);
    return result;
}

/** User Role Manage Controller  按条件查询子账号 */
export async function queryPageChildrenUserByConditionUsingPOST(params: { param: model.IQueryPageChildrenUserParam }) {
    const result = await axios.post<model.IMessageQueryPageChildrenUserVO>(
        `/rest/merchant/apicenter/subAccount/list`,
        { ...params.param }
    );
    return result;
}

/** User Role Manage Controller  修改子账号 */
// export async function getSignedMerchant(params: model.IGetSignedMerchantsVO) {
//     const paramArr: string[] = [];
//     for (const key in params) {
//         paramArr.push(
//             `${key}=${
//                 typeof (params as any)[key] === 'string' ? (params as any)[key] : JSON.stringify((params as any)[key])
//             }`
//         );
//     }
//     const result = await axios.get<model.IMessagestring>(
//         `/rest/lbs/merchant/service-provider/getSignedMerchant?${paramArr.join('&')}`
//     );
//     return result;
// }

/** User Role Manage Controller  查询登录用户关联商家信息 */
export async function getMerchantList(params: model.IGetAccountList) {
    const paramArr: string[] = [];
    for (const key in params) {
        paramArr.push(
            `${key}=${
                typeof (params as any)[key] === 'string' ? (params as any)[key] : JSON.stringify((params as any)[key])
            }`
        );
    }
    const result = await axios.get<model.IResponseAccountList>(`${services.getAccountList}?${paramArr.join('&')}`);
    return result;
}

/** User Role Manage Controller 获取用户岗位 */
export async function getRoleList() {
    const result = await axios.post<model.IGetRoleListV0>(`/rest/merchant/account/role/list`);
    return result;
    // return [
    //     {
    //         id: 111,
    //         roleCode: 'dddd-eeee',
    //         roleName: '管理员',
    //     },
    //     {
    //         id: 1112,
    //         roleCode: 'ssss-eeee',
    //         roleName: '运营',
    //     },
    // ];
}

/** 根据uid搜索快手用户信息 */
export async function searchUserByUid(params: { uid: string; addQuery: boolean }) {
    const result = await axios.get<model.IMessageSearchUserByIdResultVO>(
        `/rest/merchant/account/getKsUser?ksUserId=${params.uid}&addQuery=${params.addQuery}`
    );
    return result;
}

/** 导出数据 */
// export async function outputDataUsingPOST(params: { param: model.IQueryPageChildrenUserParam }) {
//     const result = await axios.post<{
//         data: string;
//         message: string;
//         status: number;
//     }>(`/rest/merchant/account/staffUser/export`, { ...params.param });
//     return result;
// }
/** 导出全部数据 */
export async function outputDataUsingPOST(params: { param: model.IQueryPageChildrenUserParam }) {
    const result = await axios.post<{
        data: string;
        message: string;
        status: number;
    }>(`/rest/merchant/export/exportStaffUser`, { ...params.param });
    return result;
}

/** 查询服务商子账号 */
export async function queryServiceStaffUserList(params: model.IQueryServiceStaffUserListParam) {
    return await axios.post<model.IQueryServiceStaffUserListResultVO>(
        `rest/merchant/apicenter/account/queryServiceStaffUserList`,
        { ...params }
    );
}
/** 查询服务商子账号 */
export async function queryAccessPoiPage(params: model.IQueryAccessPoiPageParam) {
    return await axios.post<model.IQueryAccessPoiPageVO>(
        `/rest/merchant/account/staffUser/queryAccessPoiPage`,
        { ...params }
    );
}
/** 子账号导出记录查询 */
export async function queryStaffUserExportRecord(params: model.IQueryAccessPoiPageParam) {
    return await axios.post<model.IQueryStaffUserExportRecordVO>(
        `/rest/merchant/export/queryStaffUserExportRecord`,
        { ...params }
    );
}
/** 批量创建子账号模板下载 */
export async function queryBatchAddStaffUser() {
    return await axios.post<model.IQueryBatchAddStaffUserVO>(
        `/rest/merchant/staffUser/batchAddTemplate?templateKey=batchAddStaffUser`
    );
}
/** 上传文件 */
export async function uploadFilePost(formdata: FormData) {
    return await axios.post<model.IUploadStaffUserVO>(`/rest/merchant/staffUser/uploadFile`, formdata);
}
/** 上传子账号 */
export async function batchAddStaffUser({newBlobKey, fileName}: {newBlobKey: string, fileName: string}) {
    return await axios.post<model.IMessageBatchAddStaffUserVO>(`/rest/merchant/staffUser/batchAdd`, {
        newBlobKey,
        fileName,
    });
}
/** 上传子账号历史记录 */
export async function getBatchAddRecords({currentPage, pageSize}: {currentPage: string, pageSize: string}) {
    return await axios.post<model.IMessageBatchAddRecordsVO>(`/rest/merchant/staffUser/getBatchAddRecords`, {
        currentPage,
        pageSize,
    });
}
/** 子账号导出记录查询 */
export async function getBatchAddSuccess(params: model.IQueryAccessPoiPageParam) {
    return await axios.post<model.IQueryStaffUserExportRecordVO>(
        `/rest/merchant/staffUser/getBatchAddSuccess`,
        { ...params }
    );
}
/** 子账号导出失败记录查询 */
export async function getBatchAddFail(params: model.IQueryAccessPoiPageParam) {
    return await axios.post<model.IQueryStaffUserExportRecordFailVO>(`/rest/merchant/staffUser/getBatchAddFail`, { ...params });
}
/** 子账号导出门店查询 */
export async function getRecordPoiPage(params: model.IQueryAccessPoiPageParam) {
    return await axios.post<model.IQueryAccessPoiPageVO>(`/rest/merchant/staffUser/getRecordPoiPage`, { ...params });
}

/** 子账号岗位角色权限信息 **/
export async function getPermissionInfo(type) {
    const { data = [] } = await axios.get<any>(`/rest/merchant/apicenter/auth/queryPermitListByRoleId?roleId=${type}`);
    return data;
}
